import { Row, Col, Typography } from 'antd';

const DMARCDescription = () => {
  return (
    <Row justify="center">
      <Col span={24} style={{ textAlign: 'center' }}>
        <h2>What exactly is DMARC Enforcement?</h2>
        <Typography.Paragraph>
          Prevent bad actors from sending unauthorized emails from your domain. With our DMARC
          Enforcement solutions from EasyDMARC, you’ll be able to mitigate risk of email abuse,
          improve email deliverability so your message lands in the inbox, and reach compliance with
          new Gmail and Yahoo! email authentication requirements. Domain-based Message,
          Authentication, Reporting, and Conformance (DMARC) is an email security protocol that
          verify senders utilizing DKIM & SPF protocols. After reaching DMARC enforcement levels of
          p=reject/quanrantine, you can start leveraging BIMI (Brand Indicator for Message
          Identification) and VMCs (Verified Mark Certificates) which allows brands to display
          verified logos next to your email message, boosting brand awareness and open rates. And
          Brandymail™ is here to simplify the entire journey.
        </Typography.Paragraph>
      </Col>
    </Row>
  );
};

export default DMARCDescription;
